module.exports = __webpack_public_path__ + "img/ico-back.fdcaf944.svg";